import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GeographicalRegion } from '../models/geographical-region.model';
import { Observable } from 'rxjs';
import { ResponsePackage } from '../models/util.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root',
})
export class GeographicalRegionService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + "cim/GeographicalRegion/";
  }

  save(region: GeographicalRegion): Observable<any> {
    return this.http.post(`${this.pathApi}create`, region, {headers: this.headers, observe: 'response'});
  }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAllForSelect(utilityId: number | null = null) {
      if(utilityId) {
          return this.http.get<ResponsePackage<GeographicalRegion[]>>(`${this.pathApi}getAllForSelect/${utilityId}`,{headers: this.headers, observe: 'response'});
      }
      else {
          return this.http.get<ResponsePackage<GeographicalRegion[]>>(`${this.pathApi}getAllForSelect`,{headers: this.headers, observe: 'response'});
      }
  }
}
